<!--
 * @Description: 关联线索
 * @Author: cxh
 * @Date: 2023-04-11 10:25:14
 * @LastEditTime: 2023-05-19 10:27:37
 * @LastEditors: cxh
-->
<template>
  <cos-modal v-model:visible="visible" title="关联线索" width="670px" @ok="handleSubmit" :confirmLoading="loading">
    <a-form :model="form" ref="formRef" v-if="visible">
      <a-form-item name="clueId" label="客户名称" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="form.customerName" placeholder="请输入" disabled />
      </a-form-item>
      <a-form-item name="acceptorClueId">
        <template #label>
          <span>线索线索ID</span>
          <p style="margin-left: 5px; color: #7f7f7f">(取消关联请删除销售线索ID)</p>
        </template>
        <CosInput v-model:value="form.acceptorClueId" placeholder="请输入" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { clueRelate } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import { Modal } from 'ant-design-vue'
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const form = ref<any>({})
const emit = defineEmits(['success'])
const showModal = (row: ClueManage) => {
  form.value = {
    clueId: row.clueId,
    customerName: row.customerName,
    acceptorClueId: row?.track?.acceptorClueId
  }
  visible.value = true
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    postData(false)
  })
}
const postData = (occupyConfirmFlag: boolean) => {
  loading.value = true
  const p: any = {}
  clueRelate(
    {
      ...form.value,
      occupyConfirmFlag
    },
    { custom: { errorMsg: false } }
  )
    .then((res) => {
      if (res.code === 13000069) {
        DcConfirm.warning({
          title: '操作提示！',
          content: res.message,
          cancelText: '取消',
          okText: '继续',
          onOk() {
            postData(true)
          }
        })
      } else if (res.code === 200) {
        if (form.value.acceptorClueId) {
          DcMessage.success('关联线索成功')
        } else {
          DcMessage.success('取消关联成功')
        }
        visible.value = false
        emit('success')
      } else {
        DcMessage.error(res.message)
      }
    })
    .finally(() => {
      loading.value = false
    })
}
defineExpose({ showModal })
</script>
<script lang="ts">
export default { name: 'relevanceClue' }
</script>
